import {getImagePathWithTheme, getImagePathWithThemeSvg, imgPathPerfix, isDarkMode} from "@/utils";
import Icon, {LoadingOutlined} from "@ant-design/icons";
import React from "react";

export const IconNewProject = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+'start_from_blank.png'}/>
    return <Icon component={()=>icon}/>
}
export const IconNewVideo = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('context_menu_new_video')}/>
    return <Icon component={()=>icon}/>
}
export const IconNewImage = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('context_menu_image')}/>
    return <Icon component={()=>icon}/>
}
export const IconFile = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('context_menu_file')}/>
    return <Icon component={()=>icon}/>
}
export const IconImport = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('home_popup_menu_import_1')}/>
    return <Icon component={()=>icon}/>
}
export const IconWeblink = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('context_menu_web_link')}/>
    return <Icon component={()=>icon}/>
}
export const IconCreateProject = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('home_bottom_menu_new_project')}/>
    return <Icon component={()=>icon}/>
}
export const IconCreateCard = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('home_bottom_menu_new_card')}/>
    return <Icon component={()=>icon}/>
}
export const IconImportProject = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('home_bottom_menu_import_project')}/>
    return <Icon component={()=>icon}/>
}
export const IconImportCard = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('home_bottom_menu_import_card')}/>
    return <Icon component={()=>icon}/>
}
export const IconImportFile = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('home_bottom_menu_import_file')}/>
    return <Icon component={()=>icon}/>
}
export const IconSaveToCloud = ()=>{
    const icon = <img className='img-18 mr-8' src={getImagePathWithTheme('icon_save_to_cloud.svg')}/>
    return <Icon component={()=>icon}/>
}
export const IconRefreshFromCloud = ()=>{
    const icon = <img className='img-18 mr-8' src={getImagePathWithTheme('icon_refresh_from_cloud.svg')}/>
    return <Icon component={()=>icon}/>
}
export const IconRename = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_rename.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconOpenLink = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_open_link.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconChangeSource = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_change_source.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconLocation = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"context_menu_location.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconCopyHighlight = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"context_menu_copy_highlight.svg"}/>
    return <Icon component={()=>icon}/>
}
export const IconCopyAgain00000 = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_copy.svg"}/>
    return <Icon component={()=>icon}/>
}
export const IconCopyHighlight1 = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"icon_copy_highlight_1.svg"}/>
    return <Icon component={()=>icon}/>
}
export const IconViewAllHighlight = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_view_all_highlight.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconHomeItemMakeCopy = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"home_item_make_copy.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconProject = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('info_project_black')}/>
    return <Icon component={()=>icon}/>
}
export const IconContextMenuPdf = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('content_menu_pdf')}/>
    return <Icon component={()=>icon}/>
}
export const IconContextMenuProject = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('content_menu_project')}/>
    return <Icon component={()=>icon}/>
}
export const IconContextMenuCard = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('context_menu_card_1')}/>
    return <Icon component={()=>icon}/>
}
export const IconPreference = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('preference')}/>
    return <Icon component={()=>icon}/>
}
export const IconMouse = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"icon_mouse.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconHelp = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme('help')}/>
    return <Icon component={()=>icon}/>
}
export const IconKeyboardShortcut = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"keyboard_shortcut.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconBackgroundColor = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_background_color_1.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconDelete = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("remove")}/>
    return <Icon component={()=>icon}/>
}
export const IconRelatedCardType = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("related_card_type.svg")}/>
    return <Icon component={()=>icon}/>
}
export const IconDeleteWhite = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"remove_white.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconDeleteRed = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"context_menu_remove_link.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconMoveTo = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_move_to.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconNoteSearch = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"note_search.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconSearch = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("search")}/>
    return <Icon component={()=>icon}/>
}
export const IconSearchMenu = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"search.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconOpenInPopup = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"more_menu_open_in_popup.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconOpenInFullscreen = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"more_menu_fullscreen.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconInfoMenu = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("context_menu_info")}/>
    return <Icon component={()=>icon}/>
}
export const IconVisibleFromLibrary = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("contextmenu_make_visible_from_library")}/>
    return <Icon component={()=>icon}/>
}
export const IconHiddenFromLibrary = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("contextmenu_hidden_from_library")}/>
    return <Icon component={()=>icon}/>
}
export const IconOpenInSystemExplorer = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"contextmenu_in_system_folder.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconEdit = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("contextmenu_edit")}/>
    return <Icon component={()=>icon}/>
}
export const IconMenuChecked = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"context_menu_checked.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconMenuChecked1 = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_checked_1.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconCopyLink = ()=>{
    const icon = <img className='img-14 mr-8' src={getImagePathWithTheme("context_menu_link")}/>
    return <Icon component={()=>icon}/>
}
export const IconCopyText = ()=>{
    const icon = <img className='img-14 mr-8' src={getImagePathWithThemeSvg("context_menu_copy_text")}/>
    return <Icon component={()=>icon}/>
}
export const IconImportHighlights = ()=>{
    const icon = <img className='img-14 mr-8' src={imgPathPerfix()+"menu_import_highlights.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconExportHighlights = ()=>{
    const icon = <img className='img-14 mr-8' src={imgPathPerfix()+"menu_export_highlights.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconAddFolder = ()=>{
    const icon = <img className='img-14 mr-8' src={getImagePathWithTheme("menu_add_folder.svg")}/>
    return <Icon component={()=>icon}/>
}

export const IconAddLink = ()=>{
    const icon = <img className='img-14 mr-8' src={getImagePathWithTheme('menu_add_link.svg')}/>
    return <Icon component={()=>icon}/>
}

export const IconRestore = ()=>{
    return imgIcon("restore");
}
export const IconForeverDelete = ()=>{
    return imgIcon("forever_delete");
}
export const IconAddToProject = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_add_to_project.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconNoteRename = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"rename.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconNoteMakeCopy = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"note_make_copy.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconNoteDelete = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"note_delete.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconNoteSearch1 = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"note_search.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconMenuExportItem = ()=>{
    const icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+"menu_export_item.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconClose = ()=>{
    const icon = <img className='img-mini-small-10 cursor-pointer' src={imgPathPerfix()+(isDarkMode()?"close_white_1.png":"close_black.png")}/>
    return <Icon component={()=>icon}/>
}

export const IconClose20 = ()=>{
    const icon = <img className='img-20 cursor-pointer' src={getImagePathWithThemeSvg('close_close_close_new_new_20')}/>
    return <Icon component={()=>icon}/>
}

export const IconCloseBlackImage = ()=>{
    const icon = <img className='img-mini-small-10 cursor-pointer'  src={imgPathPerfix()+"close_black.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconCloseBlack = ()=>{
    const icon = <img className='img-mini-small-10 cursor-pointer' src={imgPathPerfix()+(isDarkMode()?"close_white_1.png":"close_black.png")}/>
    return <Icon component={()=>icon}/>
}

export const IconCloseWhite = ()=>{
    const icon = <img className='img-mini-small-10 hovered-circle filter-img-white' src={imgPathPerfix()+"close_white_1.png"}/>
    return <Icon component={()=>icon}/>
}


export const IconWebBrowseSearch = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_search')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseCopylink = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_copylink')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseOpenInPopup = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_open_in_popup')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseOpenFullscreen = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_open_fullscreen')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseOpenInDefault = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_open_in_default')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseAddToLibrary = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_add_to_library')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseOpenFromLibrary = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_open_from_library')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseSet = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_set')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseZoomIn = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_zoomin')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseResetZoom = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_reset_zoom')}/>
    return <Icon component={()=>icon}/>
}
export const IconWebBrowseZoomOut = ()=>{
    const icon = <img className='img-14 cursor-pointer mr-8' src={getImagePathWithThemeSvg('webbrowse_zoomout')}/>
    return <Icon component={()=>icon}/>
}


//下拉的三角样式
export const IconDropdown = ()=> {
    return <img className='img-mini-small-10' style={{width: '10px', height: '6px', marginLeft: '4px'}}
         src={imgPathPerfix() + (isDarkMode()?"home_dropdown_white.png":"home_dropdown.png")}/>
}

export const IconPageBlack = () => {
    return imgIcon("transparent");
}
export const IconBoard = () => {
    return imgIconWithTheme("board.svg");
}
export const IconPageCheck = () => {
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("check_black")}/>
    return <Icon component={()=>icon}/>
}
export const IconPageWhite = ()=>{
    return imgIcon("page_white");
}
export const IconFrame = ()=>{
    // return imgIcon("tree_frame");
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("tree_frame")}/>
    return <Icon component={()=>icon}/>
}
export const IconPdf = ()=>{
    // return imgIcon("tree_frame");
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("choose_card_pdf")}/>
    return <Icon component={()=>icon}/>
}
export const IconUndo = ()=>{
    return imgIcon("undo");
}
export const IconRedo = ()=>{
    return imgIcon("redo");
}
export const IconVersionHistory = ()=>{
    return imgIcon("version_history");
}
export const IconNote = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("icon_note")}/>
    return <Icon component={()=>icon}/>
}
export const IconJournal = ()=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme("deeplink_journal")}/>
    return <Icon component={()=>icon}/>
}

export const IconLinkNote = ()=>{
    const icon = <img style={{width:'16px',height:'16px'}} className='img-mini-small mr-8' src={getImagePathWithTheme("info_link_card")}/>
    return <Icon component={()=>icon}/>
}
export const IconLinkJournal = ()=>{
    const icon = <img style={{width:'16px',height:'16px'}} className='img-mini-small mr-8' src={getImagePathWithTheme("info_link_journal")}/>
    return <Icon component={()=>icon}/>
}

export const IconTransparent = ()=>{
    return imgIcon("transparent");
}
export const IconFolder = ()=>{
    return imgIcon("folder");
}
export const IconFavorFolderNew = ()=>{
    return imgIconWithTheme("favor_folder_new.svg");
}
export const IconFavorFolder = ()=>{
    return imgIconWithTheme("favor_folder.svg");
}
export const IconOfflineOpen = ()=>{
    return imgIcon("offline_open_menu");
}
export const IconTreeFolder = ()=>{
    return imgIcon("tree_folder");
}

export const IconTreeFolderCollapse = ()=>{
    return imgIconWithTheme("tree_folder_collapse.svg");
}

export const IconTreeFolderExpand = ()=>{
    return imgIconWithTheme("tree_folder_expand.svg");
}

export const IconMoveToFolder = ()=>{
    return imgIcon("move_folder")
}
export const IconAddToFavor = ()=>{
    return imgIconWithTheme("add_to_favor")
}
export const IconRemoveFavor = ()=>{
    return imgIcon("item_remove_favor")
}
export const IconAddToFavorNew = ()=>{
    return imgIconWithTheme("menu_add_to_favor_new")
}
export const IconRemoveFavorNew = ()=>{
    return imgIcon("menu_remove_to_favor_new")
}

export const IconAddToFavorWithTheme = ()=>{
    return imgIconWithTheme("add_to_favor")
}
export const IconRemoveFavorWithTheme = ()=>{
    return imgIconWithTheme("item_remove_favor")
}

export const IconHelperDiscordCommunity = ()=>{
    return imgIconWithTheme("menu_helper_discord_community")
}
export const IconHelperToutorialVideo = ()=>{
    return imgIconWithTheme("menu_helper_toutorial_video")
}
export const IconHelperCenter = ()=>{
    return imgIconWithTheme("menu_helper_center")
}
export const IconHelperChangelog = ()=>{
    return imgIconWithTheme("menu_helper_change_log")
}
export const IconHelperRoadmap = ()=>{
    return imgIconWithTheme("menu_helper_roadmap")
}
export const IconHelperShortcuts = ()=>{
    return imgIconWithTheme("menu_helper_shortcuts")
}

export const IconFavorClose = ()=>{
    return imgIcon("favor_close")
}
export const IconMakeCopy = ()=>{
    const icon = <img className='img-14 mr-6' src={imgPathPerfix()+"make_copy.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconManagerTags = ()=>{
    const icon = <img className='img-14 mr-8' style={{width:'13px',height:'13px',marginLeft:'0px'}} src={getImagePathWithTheme("home_tags_normal")}/>
    return <Icon component={()=>icon}/>
}
export const IconMakeCopy_L2 = ()=>{
    const icon = <img className='img-14 mr-8' style={{width:'13px',height:'13px'}} src={imgPathPerfix()+"make_copy.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconDrawFavor = ()=>{
    return imgIcon("draw_favorites")
}
export const IconDrawMakeCopy = ()=>{
    return imgIcon("draw_make_a_copy")
}
export const IconMenuExportProject = ()=>{
    return imgIcon("menu_export_project")
}
export const IconMenuExportPcanvasx = ()=>{
    return imgIcon("menu_export_pcanvasx")
}
export const IconMenuExportPcanvas = ()=>{
    return imgIcon("menu_export_pcanvas")
}
export const IconMenuExportAsPng = ()=>{
    return imgIcon("menu_export_as_png")
}
export const IconMenuExportAsPdf = ()=>{
    return imgIcon("menu_export_as_pdf")
}
export const IconMenuExportPcanvasWhite = ()=>{
    return imgIcon("menu_export_pcanvas_white")
}
export const IconMenuExportAsPngWhite = ()=>{
    return imgIcon("menu_export_as_png_white")
}
export const IconMenuExportAsPdfWhite = ()=>{
    return imgIcon("menu_export_as_pdf_white")
}

export const IconDropdownTriangle = ()=>{
    const icon = <img className='img-mini-small mr-8 ml-8' style={{width:'8px',height:'8px'}} src={imgPathPerfix()+"drop_down_triangle.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconAddBlack = ()=>{
    const icon = <img className='img-mini-small-12' src={imgPathPerfix()+"add_black.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconDropdownTriangleNoMargin = ()=>{
    const icon = <img className='img-mini-small' style={{width:'8px',height:'8px'}} src={imgPathPerfix()+"drop_down_triangle.png"}/>
    return <Icon component={()=>icon}/>
}
export const IconCreateFolder = ()=>{
    const icon = <img className='img-mini-small' src={imgPathPerfix()+"create_folder.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconNoteMenuTodo = ()=>{
    return imgIcon("note_menu_todo.png")
}


export const IconDropdownSelected = ()=>{
    const icon = <img className='img-mini-small-10' src={getImagePathWithTheme('drop_down_select')}/>
    return <Icon component={()=>icon}/>
}

export const IconDropdownGray = ()=>{
    const icon = <img className='img-mini-small-12' src={imgPathPerfix()+"drop_down_gray.png"}/>
    return <Icon component={()=>icon}/>
}


export const IconDropdownBlack = ()=>{
    const icon = <img style={{width:'8px',height:'5px'}} className='img-mini-small-12' src={getImagePathWithTheme("home_dropdown")}/>
    return <Icon component={()=>icon}/>
}

export const IconDropdownWhite = ()=>{
    const icon = <img className='img-mini-small-10' src={imgPathPerfix()+"drop_down_white.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconHomeSearch = ()=>{
    const icon = <img className='img-16' src={getImagePathWithTheme("home_search.svg")}/>
    return <Icon component={()=>icon}/>
}

export const IconSearchPdfCard = ()=>{
    const icon = <img className='img-16' src={getImagePathWithTheme("home_search.svg")}/>
    return <Icon component={()=>icon}/>
}

export const IconLoadingIndicator = ()=>{
    const icon = <img className='rotating-image' style={{width:'44px',height:'44px'}} src={imgPathPerfix()+"loading_indicator.png"}/>
    return <Icon component={()=>icon}/>
}

export const IconPropertyImportFromCSV = ()=>{
    return imgIcon("import_from_csv.svg")
}

export const IconPropertyExportToCSV = ()=>{
    return imgIcon("export_to_csv.svg")
}

export const IconPropertyCopyToClipboard = ()=>{
    return imgIcon("property_copy_to_clipboard.svg")
}

export const IconPropertyDuplicateDatabase = ()=>{
    return imgIcon("duplicate_database.svg")
}

export const IconIndicatorWhite = <LoadingOutlined style={{ fontSize:'44px',color:'white' }} spin />;
export const IconIndicatorBlue = <LoadingOutlined style={{ fontSize:'34px'}} spin />;


export const mindmapRemove = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Vector">
<g id="Frame 1321316268">
<rect width="12" height="12" rx="6" fill="black" fill-opacity="0.2"/>
<path id="Vector_2" d="M8.85377 3.14632C8.93842 3.23114 8.98983 3.34352 8.99864 3.46304C9.00746 3.58255 8.97309 3.70126 8.9018 3.79758L8.85377 3.85386L6.70634 6.00126L8.85377 8.14865C8.94183 8.2382 8.993 8.3576 8.99712 8.48313C9.00123 8.60866 8.958 8.73115 8.876 8.82628C8.794 8.92142 8.67922 8.98224 8.55445 8.99668C8.42969 9.01112 8.30405 8.97812 8.20248 8.90423L8.14621 8.8562L5.99877 6.70881L3.85133 8.8562C3.76177 8.94425 3.64238 8.9954 3.51685 8.99951C3.39133 9.00362 3.26885 8.96039 3.17372 8.87839C3.07859 8.7964 3.01777 8.68163 3.00332 8.55688C2.98888 8.43212 3.02187 8.3065 3.09574 8.20493L3.14377 8.14866L5.2912 6.00126L3.14377 3.85386C3.05573 3.7643 3.00457 3.64491 3.00046 3.51939C2.99635 3.39387 3.03958 3.27139 3.12158 3.17626C3.20358 3.08113 3.31834 3.02031 3.4431 3.00587C3.56786 2.99142 3.69349 3.02441 3.79505 3.09829L3.85133 3.14632L5.99877 5.29371L8.1462 3.14632C8.34129 2.95123 8.65793 2.95123 8.85377 3.14632Z" fill="white"/>
</g>
</g>
</svg>`


const imgIcon = (szImgName:string)=>{
    let icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+szImgName+".png"}/>
    if (szImgName.endsWith('svg')){
        icon = <img className='img-mini-small mr-8' src={imgPathPerfix()+szImgName}/>
    }
    return <Icon component={()=>icon}/>
}

const imgIconWithTheme = (szImgName:string)=>{
    const icon = <img className='img-mini-small mr-8' src={getImagePathWithTheme(szImgName)}/>
    return <Icon component={()=>icon}/>
}


export const getMindmapLayoutLR = (szHexColor:any)=> {
    return <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icon/pop/link">
            <rect id="Rectangle 34625539" y="0.5" width="30" height="30" rx="6.42857" fill="#D9D9D9"
                  fill-opacity="0.01"/>
            <g id="Group 427322202">
                <path id="Vector 1065" d="M16.0857 16.009H22.2654" stroke={`${szHexColor}`} strokeWidth="1.2"
                      strokeLinecap="round"/>
                <path id="Vector 1065_2" d="M16.0857 21.809H22.2654" stroke={`${szHexColor}`} strokeWidth="1.2"
                      strokeLinecap="round"/>
                <path id="Vector 1063" d="M7.73462 15.9757L12.5675 15.9757" stroke={`${szHexColor}`}
                      strokeWidth="1.2" strokeLinecap="round"/>
                <path id="Vector 1065_3" d="M16.0857 10.0867H22.2654" stroke={`${szHexColor}`}
                      strokeWidth="1.2" strokeLinecap="round"/>
                <path id="Vector 1064"
                      d="M12.5644 10.0045C12.0909 9.9473 11.221 10.5782 11.0257 13.6291C10.9503 14.807 10.6632 15.6914 9.55615 15.956"
                    stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
                <path id="Vector 1064_2"
                      d="M12.5402 21.911C12.0686 21.9823 11.2973 21.3549 11.0107 18.3112C10.9 17.1361 10.5865 16.2607 9.47202 16.0294"
                    stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
            </g>
        </g>
    </svg>
}

export const getMindmalLayoutTB = (szHexColor:any)=> {
    return <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icon/pop/link">
            <rect id="Rectangle 34625539" y="0.5" width="30" height="30" rx="6.42857" fill="#D9D9D9"
                  fill-opacity="0.01"/>
            <g id="Group 427322202">
                <path id="Vector 1065" d="M14.9919 17.0867L14.9919 23.2664" stroke={`${szHexColor}`} strokeWidth="1.2"
                      strokeLinecap="round"/>
                <path id="Vector 1065_2" d="M9.19189 17.0867L9.19189 23.2664" stroke={`${szHexColor}`} strokeWidth="1.2"
                      strokeLinecap="round"/>
                <path id="Vector 1063" d="M15.0251 8.73572L15.0251 13.5686" stroke={`${szHexColor}`} strokeWidth="1.2"
                      strokeLinecap="round"/>
                <path id="Vector 1065_3" d="M20.9143 17.0867V23.2664" stroke={`${szHexColor}`} strokeWidth="1.2"
                      strokeLinecap="round"/>
                <path id="Vector 1064"
                      d="M20.9965 13.5655C21.0537 13.092 20.4228 12.2221 17.3718 12.0268C16.1939 11.9514 15.3095 11.6643 15.045 10.5573"
                      stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
                <path id="Vector 1064_2"
                      d="M9.09001 13.5413C9.01869 13.0697 9.64609 12.2984 12.6898 12.0118C13.8649 11.9011 14.7403 11.5876 14.9715 10.4731"
                      stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
            </g>
        </g>
    </svg>
}

export const getMindmalLayoutCenter = (szHexColor:any)=> {
    return <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="icon/pop/link">
            <rect id="Rectangle 34625539" y="0.5" width="30" height="30" rx="6.42857" fill="#D9D9D9"
                  fill-opacity="0.01"/>
            <g id="Group 427322202">
                <g id="Group 427322958">
                    <path id="Vector 1064"
                          d="M8 9.00268C8.78705 8.95468 10.233 9.48441 10.5575 12.0461C10.6828 13.0351 11.16 13.7777 13 13.9998"
                          stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
                    <path id="Vector 1064_2"
                          d="M8.04346 22.9236C8.892 22.9832 10.2798 22.4594 10.7956 19.9185C10.9947 18.9375 11.5587 18.2068 13.564 18.0137"
                          stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
                </g>
                <g id="Group 427322959">
                    <path id="Vector 1064_3"
                          d="M22 9.00268C21.213 8.95468 19.767 9.48441 19.4425 12.0461C19.3172 13.0351 18.84 13.7777 17 13.9998"
                          stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
                    <path id="Vector 1064_4"
                          d="M21.9572 22.9246C21.1141 22.9842 19.7353 22.4604 19.2229 19.9195C19.025 18.9385 18.4646 18.2077 16.4723 18.0147"
                          stroke={`${szHexColor}`} strokeWidth="1.2" strokeLinecap="round"/>
                </g>
                <g id="Rectangle 34626444">
                    <mask id="path-6-inside-1_1_1869" fill="white">
                        <rect x="9" y="11.9988" width="12" height="8" rx="1"/>
                    </mask>
                    <rect x="9" y="11.9988" width="12" height="8" rx="1" fill="white" stroke={`${szHexColor}`}
                          strokeWidth="2.4" mask="url(#path-6-inside-1_1_1869)"/>
                </g>
            </g>
        </g>
    </svg>
}

export const getCardFontColor = (szHexColor:any)=> {
    //393834
    return <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427321165">
            <g id="Frame 1321315853" clipPath="url(#clip0_17_2063)">
                <path id="A"
                      d="M17.892 18.944H12.654L11.754 21.5H9.612L14.094 8.972H16.47L20.952 21.5H18.792L17.892 18.944ZM17.316 17.27L15.282 11.456L13.23 17.27H17.316Z"
                      fill={`${szHexColor}`}/>
                <rect id="Rectangle 34626194" x="3.5" y="4" width="23" height="23" rx="5.5" stroke="#E3E3E3"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_17_2063">
                <rect width="30" height="30" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
        </defs>
    </svg>
}

/**
 * 带颜色的card
 * @param szHexColor
 */
export const getCardElementIcon = (szHexColor:any = '#393834')=> {
    if (!szHexColor){
        szHexColor = '#393834';
    }
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3_4436)">
            <mask id="mask0_3_4436" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
                  height="16">
                <path d="M16 0H0V16H16V0Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_3_4436)">
                <path
                    d="M1.87598 0.599609H14.4453C14.7456 0.599609 14.989 0.843317 14.9893 1.14355V14.8564C14.989 15.1567 14.7456 15.4004 14.4453 15.4004H1.87598C1.57589 15.4002 1.33227 15.1565 1.33203 14.8564V1.14355C1.33227 0.843465 1.57589 0.59985 1.87598 0.599609Z"
                    stroke={szHexColor} strokeWidth="1.2"/>
                <path
                    d="M11.5352 10.891C11.8507 10.891 12.1064 11.1467 12.1064 11.4623C12.1064 11.7778 11.8507 12.0336 11.5352 12.0336H4.78516C4.4696 12.0336 4.21392 11.7778 4.21387 11.4623C4.21387 11.1467 4.46957 10.891 4.78516 10.891H11.5352ZM11.5352 7.4281C11.8507 7.4281 12.1064 7.68478 12.1064 8.00037C12.1062 8.31576 11.8506 8.57166 11.5352 8.57166H4.78516C4.46971 8.57166 4.2141 8.31576 4.21387 8.00037C4.21387 7.68478 4.46957 7.4281 4.78516 7.4281H11.5352ZM7.24219 3.96619C7.55767 3.96623 7.81336 4.22201 7.81348 4.53748C7.81348 4.85304 7.55774 5.10872 7.24219 5.10876H4.78516C4.46957 5.10876 4.21387 4.85307 4.21387 4.53748C4.21399 4.22199 4.46964 3.96619 4.78516 3.96619H7.24219Z"
                    fill={szHexColor}/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_3_4436">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>


}


export const getFrameElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427320713">
            <path id="Vector 584" d="M0.888916 3.55554H15.1111" stroke={szHexColor} strokeWidth="1.2"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector 585" d="M0.888916 12.4445H15.1111" stroke={szHexColor} strokeWidth="1.2"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector 586" d="M12.4443 0.888916L12.4443 15.1111" stroke={szHexColor} strokeWidth="1.2"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path id="Vector 587" d="M3.55566 0.888916L3.55566 15.1111" stroke={szHexColor} strokeWidth="1.2"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>

}

export const getStickNoteElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Frame" clipPath="url(#clip0_6_4056)">
            <g id="Group 427323043">
                <path id="Vector"
                      d="M1.43774 15.4004H9.51001V10.5C9.51001 9.89249 10.0021 9.40039 10.6096 9.40039H14.9006V0.799805C14.9006 0.778344 14.8914 0.737542 14.8362 0.69043C14.7795 0.642142 14.6846 0.599609 14.5627 0.599609H1.43774C1.31585 0.599609 1.22098 0.642138 1.16431 0.69043C1.10909 0.737546 1.09991 0.778351 1.09985 0.799805V15.2002C1.09991 15.2216 1.10909 15.2624 1.16431 15.3096C1.22098 15.3579 1.31586 15.4004 1.43774 15.4004Z"
                      stroke={szHexColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path id="Vector_2" d="M9.60034 15.5L14.9003 9.5" stroke={szHexColor} strokeWidth="1.06667"
                      strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </g>
        <defs>
            <clipPath id="clip0_6_4056">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>

}

export const getImageElementIcon = (szHexColor:any = '#393834') => {
    if (!szHexColor){
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.5625" y="2.0625" width="13.875" height="12.875" rx="0.595588" stroke={szHexColor} strokeWidth="1.125"
              strokeLinejoin="round"/>
        <path d="M1.79639 13.5199L9.29777 7.79115C10.4151 6.93787 11.9158 6.78121 13.1853 7.38536L15.5768 8.52349"
              stroke={szHexColor} strokeWidth="1.125"/>
        <path
            d="M4.93848 6.82105C5.21198 6.82105 5.47428 6.7124 5.66768 6.519C5.86108 6.3256 5.96973 6.0633 5.96973 5.7898C5.96973 5.51629 5.86108 5.25399 5.66768 5.06059C5.47428 4.86719 5.21198 4.75854 4.93848 4.75854C4.66497 4.75854 4.40267 4.86719 4.20927 5.06059C4.01588 5.25399 3.90723 5.51629 3.90723 5.7898C3.90723 6.0633 4.01588 6.3256 4.20927 6.519C4.40267 6.7124 4.66497 6.82105 4.93848 6.82105Z"
            fill={szHexColor}/>
    </svg>

}

export const getMindmapElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.48535 8.71362H15.3614" stroke={szHexColor} strokeWidth="1.13002" strokeLinecap="round"/>
        <path d="M9.48535 14.3525H15.3614" stroke={szHexColor} strokeWidth="1.13002" strokeLinecap="round"/>
        <path d="M1.5 8.68188L6.06515 8.68189" stroke={szHexColor} strokeWidth="1.13002" strokeLinecap="round"/>
        <path d="M9.48535 2.95703H15.3614" stroke={szHexColor} strokeWidth="1.13002" strokeLinecap="round"/>
        <path
            d="M6.06252 2.87716C5.6022 2.8216 4.75653 3.43489 4.56671 6.40068C4.49343 7.5457 4.21435 8.40543 3.13818 8.66256"
            stroke={szHexColor} strokeWidth="1.13002" strokeLinecap="round"/>
        <path
            d="M6.03896 14.4516C5.58051 14.5209 4.8307 13.911 4.55206 10.9522C4.44448 9.80992 4.13975 8.95895 3.05636 8.73419"
            stroke={szHexColor} strokeWidth="1.13002" strokeLinecap="round"/>
    </svg>


}


export const getPdfElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3_4433)">
            <path
                d="M8.24024 6.60406L8.24804 6.56765C8.39883 5.94612 8.58862 5.17114 8.44043 4.46898C8.34164 3.91506 7.93347 3.69921 7.58509 3.68361C7.17432 3.66541 6.80774 3.89946 6.71675 4.24013C6.54516 4.86427 6.69855 5.71726 6.97933 6.80431C6.62576 7.64689 6.0616 8.87177 5.64823 9.59993C4.87868 9.99782 3.84655 10.6116 3.69316 11.3865C3.66197 11.5296 3.69836 11.7116 3.78416 11.8754C3.88035 12.0575 4.03374 12.1979 4.21313 12.2655C4.29112 12.2941 4.38471 12.3175 4.49391 12.3175C4.95148 12.3175 5.69242 11.9483 6.68035 10.2527C6.83114 10.2033 6.98713 10.1513 7.13792 10.0992C7.84507 9.85999 8.57822 9.61033 9.24117 9.49851C9.97432 9.8912 10.8089 10.1435 11.3756 10.1435C11.9372 10.1435 12.1582 9.81058 12.2414 9.61033C12.387 9.25926 12.3168 8.81716 12.0802 8.5805C11.737 8.24243 10.9025 8.15401 9.60255 8.31525C8.96299 7.92516 8.54442 7.39464 8.24024 6.60406ZM5.38824 10.5543C5.02687 11.0797 4.75389 11.3423 4.6057 11.4567C4.77989 11.1369 5.12046 10.7988 5.38824 10.5543ZM7.66568 4.42998C7.80087 4.66143 7.78268 5.36098 7.67868 5.71466C7.55129 5.19715 7.53309 4.46378 7.60849 4.37796C7.62929 4.38056 7.64749 4.39617 7.66568 4.42998ZM7.62409 7.56368C7.90227 8.04478 8.25324 8.45828 8.64062 8.76515C8.07906 8.89257 7.56689 9.10322 7.10932 9.29046C7.00013 9.33467 6.89354 9.37888 6.78955 9.42049C7.13532 8.79375 7.4239 8.08379 7.62409 7.56368ZM11.6694 9.26706C11.672 9.27226 11.6746 9.28006 11.659 9.29046H11.6538L11.6486 9.29826C11.6278 9.31127 11.4146 9.4361 10.4969 9.07462C11.5524 9.0252 11.6668 9.26446 11.6694 9.26706Z"
                fill={szHexColor}/>
            <path
                d="M1.875 0.599731H14.4443C14.7446 0.599731 14.988 0.843439 14.9883 1.14368V14.8566C14.988 15.1568 14.7446 15.4005 14.4443 15.4005H1.875C1.57491 15.4003 1.33129 15.1567 1.33105 14.8566V1.14368C1.33129 0.843587 1.57491 0.599972 1.875 0.599731Z"
                stroke={szHexColor} strokeWidth="1.2"/>
        </g>
        <defs>
            <clipPath id="clip0_3_4433">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>

}

export const getPdfElementIconForBookmarkForBookmarkForBookmark = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.74073 7.10406L8.74853 7.06765C8.89932 6.44612 9.08911 5.67114 8.94092 4.96898C8.84212 4.41506 8.43395 4.19921 8.08558 4.18361C7.67481 4.16541 7.30823 4.39946 7.21724 4.74013C7.04565 5.36427 7.19904 6.21726 7.47982 7.30431C7.12625 8.14689 6.56209 9.37177 6.14871 10.0999C5.37917 10.4978 4.34704 11.1116 4.19365 11.8865C4.16245 12.0296 4.19885 12.2116 4.28464 12.3754C4.38084 12.5575 4.53423 12.6979 4.71361 12.7655C4.79161 12.7941 4.8852 12.8175 4.9944 12.8175C5.45196 12.8175 6.19291 12.4483 7.18084 10.7527C7.33163 10.7033 7.48762 10.6513 7.63841 10.5992C8.34556 10.36 9.07871 10.1103 9.74166 9.99851C10.4748 10.3912 11.3094 10.6435 11.8761 10.6435C12.4377 10.6435 12.6587 10.3106 12.7419 10.1103C12.8874 9.75926 12.8172 9.31716 12.5807 9.0805C12.2375 8.74243 11.4029 8.65401 10.103 8.81525C9.46348 8.42516 9.04491 7.89464 8.74073 7.10406ZM5.88873 11.0543C5.52736 11.5797 5.25438 11.8423 5.10619 11.9567C5.28038 11.6369 5.62095 11.2988 5.88873 11.0543ZM8.16617 4.92998C8.30136 5.16143 8.28316 5.86098 8.17917 6.21466C8.05178 5.69715 8.03358 4.96378 8.10898 4.87796C8.12978 4.88056 8.14797 4.89617 8.16617 4.92998ZM8.12458 8.06368C8.40276 8.54478 8.75373 8.95828 9.1411 9.26515C8.57954 9.39257 8.06738 9.60322 7.60981 9.79046C7.50062 9.83467 7.39403 9.87888 7.29003 9.92049C7.63581 9.29375 7.92439 8.58379 8.12458 8.06368ZM12.1699 9.76706C12.1725 9.77226 12.1751 9.78006 12.1595 9.79046H12.1543L12.1491 9.79826C12.1283 9.81127 11.9151 9.9361 10.9974 9.57462C12.0529 9.5252 12.1673 9.76446 12.1699 9.76706Z"
            fill={szHexColor}/>
        <mask id="path-2-inside-1_19_19308" fill="white">
            <rect x="1.23145" y="0.500122" width="14.8571" height="16" rx="1.144"/>
        </mask>
        <rect x="1.23145" y="0.500122" width="14.8571" height="16" rx="1.144" stroke={szHexColor} stroke-width="1.4"
              mask="url(#path-2-inside-1_19_19308)"/>
    </svg>
}

export const getProjectElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427320674">
            <g id="Group 427322203">
                <path id="Vector 1201"
                      d="M6.00586 1.25134C6.15089 1.19226 6.31416 1.19863 6.4541 1.26892L10.0742 3.08923C10.5208 3.31374 11.042 3.3359 11.5059 3.14978L15.1553 1.68591C15.5119 1.54293 15.9004 1.80557 15.9004 2.18982V13.3851C15.9004 13.6049 15.7675 13.8032 15.5645 13.8871L11.0654 15.7426C10.9178 15.8034 10.7502 15.7963 10.6084 15.723L7.00391 13.8597C6.55074 13.6255 6.01729 13.6007 5.54492 13.7933L1.84766 15.3021C1.49074 15.4474 1.09972 15.1846 1.09961 14.7992V3.61658C1.09967 3.39605 1.23333 3.19699 1.4375 3.11365L6.00586 1.25134Z"
                      stroke={szHexColor} strokeWidth="1.2"/>
                <path id="Vector 1202" d="M6.21484 1.07092V13.6424" stroke={szHexColor} strokeWidth="1.2"/>
                <path id="Vector 1203" d="M10.7852 3.35645V15.3564" stroke={szHexColor} strokeWidth="1.2"/>
            </g>
        </g>
    </svg>

}


export const getFileElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427322279">
            <g id="Group 427322906">
                <path id="Vector 1212"
                      d="M12.3232 3.79848V12.4106C12.2312 13.9231 10.9698 15.75 8.72014 15.75C6.47045 15.75 4.76802 13.9579 4.67773 12.4106V3.79848C4.67773 2.91793 4.99283 1.25 7.66558 1.25C9.70436 1.25 10.1555 2.94899 10.1262 3.79848V11.6197C10.1262 12.4106 9.82164 13.2894 8.72014 13.2894C7.61865 13.2894 7.19741 12.4106 7.19741 11.6197L7.3811 3.79848"
                      stroke={szHexColor} strokeWidth="1.2" strokeLinecap="round"/>
            </g>
        </g>
    </svg>

}

export const getVideoElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.35" y="2.60009" width="10.4766" height="10.8" rx="1.46452" stroke={szHexColor} strokeWidth="1.2"/>
        <path d="M14.6499 11.425L11.8286 9.25211V6.74722L14.6499 4.57437V11.425Z" stroke={szHexColor} strokeWidth="1.2"/>
        <path
            d="M4.19986 4.45395C4.06854 4.45399 3.93851 4.4799 3.8172 4.5302C3.69589 4.58049 3.58568 4.65419 3.49285 4.74708C3.30538 4.93468 3.20011 5.18907 3.2002 5.45428C3.20024 5.5856 3.22615 5.71563 3.27644 5.83694C3.32674 5.95825 3.40043 6.06846 3.49332 6.16129C3.68092 6.34877 3.93531 6.45404 4.20053 6.45395C4.46575 6.45386 4.72006 6.34842 4.90754 6.16082C5.09501 5.97322 5.20028 5.71883 5.2002 5.45362C5.20011 5.1884 5.09466 4.93408 4.90707 4.74661C4.71947 4.55913 4.46508 4.45386 4.19986 4.45395Z"
            fill={szHexColor}/>
    </svg>
}

export const getTextElementIcon = (szHexColor: any = '#393834') => {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427320674">
            <g id="Group 427322838">
                <path id="Rectangle 34626207"
                      d="M1.2002 4.41963V3.46727C1.2002 2.49134 1.99134 1.7002 2.96727 1.7002H14.0719C15.0478 1.7002 15.8389 2.49134 15.8389 3.46727V4.41963"
                      stroke={szHexColor} stroke-width="1.2"/>
                <rect id="Rectangle 34626208" x="7.85693" y="1.92969" width="1.2" height="12.9101" fill={szHexColor}/>
                <rect id="Rectangle 34626209" x="4.98535" y="14.375" width="7.06828" height="1.2" fill={szHexColor}/>
            </g>
        </g>
    </svg>
}

export const getWebLinkElementIcon = (szHexColor:any = '#393834')=> {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427322280">
            <g id="Group 427322931">
                <circle id="Ellipse 2716" cx="8.47381" cy="8.34832" r="7.09734" stroke={szHexColor} stroke-width="1.2"/>
                <path id="Vector 1215"
                      d="M8.49984 1.25977C8.49984 1.25977 5.22534 4.65089 5.22534 8.4318C5.22534 12.2127 8.49984 15.4271 8.49984 15.4271"
                      stroke={szHexColor} stroke-width="1.2"/>
                <path id="Vector 1216"
                      d="M8.49979 1.25977C8.49979 1.25977 11.7743 4.65089 11.7743 8.4318C11.7743 12.2127 8.6723 15.484 8.6723 15.484"
                      stroke={szHexColor} stroke-width="1.2"/>
                <path id="Vector 1214" d="M8.49988 1.25977V15.4457" stroke={szHexColor} stroke-width="1.2"/>
                <path id="Vector 1217" d="M1.25 8.50977H15.75" stroke={szHexColor} stroke-width="1.2"/>
                <path id="Vector 1218"
                      d="M3.43323 13.5713C3.43323 13.5713 4.68006 11.4255 8.47896 11.4255C12.2779 11.4255 13.5248 13.5713 13.5248 13.5713"
                      stroke={szHexColor} stroke-width="1.2"/>
                <path id="Vector 1219"
                      d="M3.43323 3.68262C3.43323 3.68262 4.68006 5.82838 8.47896 5.82838C12.2779 5.82838 13.5248 3.68262 13.5248 3.68262"
                      stroke={szHexColor} stroke-width="1.2"/>
            </g>
        </g>
    </svg>
}

/**
 * 在线视频的
 * @param szHexColor
 */
export const getOnlineVideoElementIcon = (szHexColor = '#393834')=> {
    if (!szHexColor) {
        szHexColor = '#393834';
    }
    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427322872">
            <path id="Vector"
                  d="M8.54102 2.86133C8.56583 2.86137 8.60288 2.86215 8.65039 2.8623C8.74585 2.86262 8.88482 2.86299 9.05859 2.86426C9.40669 2.8668 9.89423 2.87168 10.4512 2.88184C11.5674 2.90219 12.9527 2.94214 14.0547 3.02246C14.3611 3.05706 14.7325 3.06892 15.1045 3.36816L15.2686 3.51953L15.2754 3.52734C15.4048 3.65958 15.5312 3.93472 15.626 4.25879C15.6693 4.40701 15.7001 4.54358 15.7197 4.64258C15.7294 4.69154 15.7359 4.731 15.7402 4.75684C15.7422 4.76856 15.7442 4.77738 15.7451 4.7832C15.7454 4.7853 15.7456 4.78824 15.7461 4.79199C15.7472 4.80103 15.7489 4.81486 15.751 4.83301C15.7552 4.86949 15.7613 4.92385 15.7686 4.99316C15.7831 5.13193 15.8027 5.33112 15.8223 5.57031C15.8615 6.05027 15.9004 6.68472 15.9004 7.31445V9.67969C15.9004 10.3094 15.8615 10.944 15.8223 11.4238C15.8027 11.6626 15.7831 11.8614 15.7686 12C15.7613 12.0692 15.7552 12.1237 15.751 12.1602C15.7489 12.1782 15.7472 12.1921 15.7461 12.2012V12.2031C15.746 12.204 15.7455 12.2063 15.7451 12.209C15.7442 12.2147 15.7424 12.2245 15.7402 12.2373C15.7359 12.2632 15.7294 12.3025 15.7197 12.3516C15.7001 12.4506 15.6693 12.5871 15.626 12.7354C15.5312 13.0597 15.4049 13.3348 15.2754 13.4668L15.2686 13.4746C14.8417 13.9248 14.4035 13.9308 14.0498 13.9717C12.9482 14.0515 11.5647 14.0937 10.4492 14.1152C9.89164 14.126 9.40322 14.1317 9.05469 14.1348C8.88063 14.1363 8.74104 14.1372 8.64551 14.1377H8.45898C8.42839 14.1374 8.38311 14.1364 8.3252 14.1357C8.20937 14.1345 8.04225 14.1326 7.83789 14.1299C7.4289 14.1244 6.87046 14.116 6.27246 14.1035C5.07388 14.0785 3.75016 14.0374 3.13184 13.9785C2.63758 13.8916 2.15499 13.9209 1.73047 13.4736L1.72363 13.4668L1.67578 13.4111C1.56364 13.2656 1.45695 13.0192 1.37402 12.7354C1.33073 12.5871 1.29987 12.4506 1.28027 12.3516C1.27057 12.3025 1.26406 12.2632 1.25977 12.2373C1.25763 12.2245 1.25576 12.2147 1.25488 12.209C1.25447 12.2063 1.25404 12.204 1.25391 12.2031V12.2012C1.25283 12.1921 1.25109 12.1782 1.24902 12.1602C1.24484 12.1237 1.23872 12.0692 1.23145 12C1.21686 11.8613 1.19728 11.6618 1.17773 11.4229C1.1385 10.9431 1.09963 10.3091 1.09961 9.67969V7.31348C1.09961 6.68411 1.13848 6.04983 1.17773 5.57031C1.19728 5.33156 1.21686 5.13275 1.23145 4.99414C1.23873 4.92493 1.24484 4.87044 1.24902 4.83398C1.2511 4.81587 1.25283 4.80203 1.25391 4.79297V4.79102C1.25404 4.7901 1.25446 4.78794 1.25488 4.78516C1.25576 4.77938 1.25763 4.76971 1.25977 4.75684C1.26406 4.73096 1.27057 4.69165 1.28027 4.64258C1.29987 4.54351 1.33073 4.40709 1.37402 4.25879C1.46865 3.93465 1.59447 3.65948 1.72363 3.52734L1.73047 3.52051C2.15608 3.07208 2.59281 3.06201 2.94434 3.02246C4.04651 2.9421 5.43226 2.9022 6.54883 2.88184C7.10577 2.87168 7.59331 2.8668 7.94141 2.86426C8.11518 2.86299 8.25415 2.86262 8.34961 2.8623C8.39712 2.86215 8.43417 2.86137 8.45898 2.86133H8.54102Z"
                  stroke={szHexColor} stroke-width="1.2" stroke-linejoin="round"/>
            <path id="Vector_2" d="M7.33325 6.45801V10.5413L10.8333 8.50667L7.33325 6.45801Z" stroke={szHexColor}
                  stroke-width="1.2" stroke-linejoin="round"/>
        </g>
    </svg>

}

/**
 * 音频图标
 * @param szHexColor
 */
export const getAudioElementIcon = (szHexColor = '#393834')=> {
    if (!szHexColor) {
        szHexColor = '#393834';
    }

    return <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 427322177">
            <g id="Group 427322910">
                <path id="Vector"
                      d="M8.99304 1.81738C9.03859 1.89148 9.08193 1.99695 9.10828 2.14844C9.14271 2.34649 9.15805 2.51668 9.15808 2.66113V14.542C9.15808 14.654 9.13736 14.7899 9.08484 14.9512C9.04416 15.076 8.99286 15.1421 8.94812 15.1807C8.94227 15.1857 8.93877 15.187 8.93347 15.1885C8.92619 15.1905 8.90336 15.1955 8.85828 15.1914C8.85395 15.1908 8.82037 15.1849 8.75281 15.1465C8.67999 15.1051 8.58428 15.0352 8.4657 14.9248L8.45789 14.918C7.95709 14.4663 7.42709 13.9953 6.86804 13.5049C6.30924 13.0147 5.78865 12.5628 5.3075 12.1504L5.30359 12.1475L3.62683 10.75L3.4364 10.5928L3.19128 10.6152C3.10174 10.6234 3.01206 10.6279 2.92273 10.6279H2.88953L2.85632 10.6309C2.79258 10.6379 2.72212 10.6426 2.64441 10.6426H2.39441C2.26297 10.6425 2.20526 10.6066 2.16687 10.5693C2.11338 10.5173 2.0995 10.478 2.09949 10.4209V6.70996C2.09949 6.57278 2.13714 6.50381 2.1864 6.45312C2.24008 6.39791 2.29587 6.37113 2.39441 6.37109H3.45105L3.61902 6.22852C4.51704 5.46715 5.33139 4.78397 6.06238 4.17969L6.06726 4.17578C6.37817 3.91345 6.68427 3.6587 6.98523 3.41113C7.28961 3.16076 7.56505 2.93154 7.8114 2.72461C8.05474 2.5202 8.25863 2.35097 8.42273 2.21582C8.58438 2.0827 8.67414 2.00996 8.70496 1.98633C8.82719 1.89673 8.91697 1.84777 8.97644 1.82324C8.98249 1.82075 8.98816 1.81919 8.99304 1.81738Z"
                      stroke={szHexColor} stroke-width="1.2"/>
                <path id="Ellipse 2735"
                      d="M12.6538 3.7002C14.3497 4.62918 15.4995 6.43063 15.4995 8.50064C15.4995 10.5707 14.3497 12.3721 12.6538 13.3011"
                      stroke={szHexColor} stroke-width="1.2" stroke-linecap="round"/>
                <path id="Ellipse 2736"
                      d="M11.0403 5.11035C12.2378 5.76635 13.0498 7.03843 13.0498 8.50016C13.0498 9.96189 12.2378 11.234 11.0403 11.89"
                      stroke={szHexColor} stroke-width="1.2" stroke-linecap="round"/>
            </g>
        </g>
    </svg>

}









